module.exports = __webpack_public_path__ + "static/media/proclaim-present-time-over.2dcc07dc.jpg";